<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchTitle()" :value="isLoaded" :caption="loadedPages === 0 ? 'Подробно' : 'Кратко '" :expandable="!((this.topCount > this.items.length) && isLoaded) && this.count > 0 ">
        <div>
          Долговых обязательств открыто <b>{{count}}</b>
            <div v-if="this.sumAmount != null">
              Сумма долга
              <b><span v-html="formatCurrency(this.sumAmount)"></span></b>
            </div>
            <div v-if="this.sumRemaining != null">
              Сумма текущего долга
              <b><span v-html="formatCurrency(this.sumRemaining)"></span></b>
            </div>
        </div>
    </v-panel-title>
    <v-panel-text v-if = "isLoading || this.items.length > 0" @click="switchText()" :value="isLoaded" :caption="isLoaded  ? 'Кратко ' : 'Еще '" :expandable="!((this.topCount > this.items.length) && isLoaded)">
      <div>
        <template v-for="item in items">
          <div>
            <div>
              <b>
              <a @click="dialogOpen(item)">
              {{item.enforcementNumber}} </a> от {{formats.blank(item.institutionDate, formats.formatDate)}}
              </b>
            </div>
            <v-flex  pl-2>
              Кредитор: <span v-if="item.collectorRef" v-html="renderReference(item.collectorRef, '_blank')"></span> <span v-if="!item.collectorRef">-</span>
              <v-component v-if="item.collectorRef" :is="renderFlags(item.collectorRef.flags, true)" />
            </v-flex>              
            <v-flex pl-2>
              <div><b>Задолженность</b> была/сейчас: <span v-html=formatCurrency(item.amount)></span>/<b><span v-html=formatCurrency(item.remaining)></span></b> - {{item.executionObject}}.
              </div>
              <div>{{item.department}}</div>
            </v-flex>
          </div>
        </template>
      </div>
      <div
        v-show="isLoading"
        class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </v-panel-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import apimix from '../common/apimix'
  import vPanelTitle from './PanelTitle'
  import vPanelText from './PanelText'
  import vEnforcementForm from './EnforcementForm'
  import dialogs from '../common/dialogs'

  export default {
    name: 'v-enforcement-debts-panel',
    components: {vPanelTitle, vPanelText},
    mixins: [apimix],
    data: () => ({
      id: null,
      items: [],
      count: null,
      sumAmount: null,
      sumRemaining: null,
      topCount: 20,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false
    }),
    props: {
      inn: {
        type: Number,
        default: null
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      if (this.ogrn) {
        this.id = this.ogrn
        this.fetchAggrs()
      }
    },
    watch: {
      inn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchAggrs()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderFlags: 'renderFlags',
        renderDateSince: 'renderDateSince'
      }),
      topItems () {
        return this.items.slice(0, this.topCount)
      },
      lowItems () {
        return this.items.slice(this.topCount)
      }
    },
    methods: {
      switchTitle () {
        if (this.loadedPages === 0) {
          this.fetchItems()
        } else {
          this.isLoaded = false
          this.loadedPages = 0
          this.items = []
        }
      },
      switchText () {
        if (!this.isLoaded) {
          this.fetchItems()
        } else {
          this.isLoaded = false
          this.loadedPages = 0
          this.items = []
        }
      },
      formatCurrency (number) {
        return number !== null ? formats.formatCurrency(number) + '&nbsp;р.' : '-'
      },
      getAggrs (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о судебных производствах '})
        }
        server.openApiGetParams(
          '/openapi/companies/' + id + '/enforcementAggrs',
          {
            litigant: 'DEBTOR',
            stage: 'OPEN'
          },
          cb,
          cbError)
      },
      fetchAggrs () {
        if (this.id) {
          this.getAggrs(this.id, (data) => {
            if (data) {
              this.count = data.count
              this.sumAmount = data.amount
              this.sumRemaining = data.remaining
            }
          })
        }
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о судебных производствах '})
        }
        server.openApiGetParams(
          '/openapi/companies/' + id + '/enforcements',
          {
            litigant: 'DEBTOR',
            stage: 'OPEN',
            size: this.topCount,
            page: this.loadedPages
          },
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = this.items.concat(data.content)
            this.loadedPages = !data.last ? data.number + 1 : data.number
            this.isLoading = false
            this.isLoaded = data.last
          })
        }
      },
      dialogOpen: function (item) {
        dialogs.register('v-enforcement-form', vEnforcementForm)
        var fullscreen = this.$vuetify.breakpoint.xsOnly
        var comp = { template: `
          <v-enforcement-form v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-enforcement-form>
        `,
          data () {
            return {
              model: item,
              fullscreen: fullscreen
            }
          }
        }
        dialogs.modal(comp)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// EnforcementDebtsPanel.vue?7f2ddc2e